import { createAsyncThunk } from '@reduxjs/toolkit'
import HttpStatus from '../../../../constants/http'
import { AlertMessages } from '../../../../constants/ui'
import { fetchPreferences } from '../../../../api/preferences'

const STATE_KEY = 'preferences'

export const fetchPreferencesThunk = createAsyncThunk(
  `${STATE_KEY}/fetch`,
  async ({ access_token }) => {
    const res = await fetchPreferences({ access_token })
    if (res.status === HttpStatus.OK) {
      return await res.json()
    }
    if (res.status === HttpStatus.INTERNAL_SERVER_ERROR) {
      throw new Error(AlertMessages.SERVER_ERROR)
    }
    if (res.status === HttpStatus.NOT_AUTHORIZED) {
      throw new Error(AlertMessages.INVALID_LOGIN_CREDENTIALS)
    }
    if (res.status === HttpStatus.INTERNAL_SERVER_ERROR) {
      throw new Error(AlertMessages.SERVER_ERROR)
    }
  },
)
